import { render, staticRenderFns } from "./FunctionHistoryTable.vue?vue&type=template&id=718c028e&lang=pug"
import script from "./FunctionHistoryTable.vue?vue&type=script&lang=ts"
export * from "./FunctionHistoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports